<div>
  <ion-chip outline color="secondary" *ngFor="let item of selectedList;let i=index;">
    <ion-icon name="close-circle" (click)="removeName(i)"></ion-icon>
    <ion-label>{{item.text}}</ion-label>
  </ion-chip>
  </div>  